export default {
  plural: 'Twins',
  singular: 'Twin',
  create: 'Create twin',
  code: 'Code',
  name: 'Name',
  integrationCodes: {
    title: 'Integration codes',
    hint: 'How an external shop refers to this option — its SKU, attribute term id, and so on. The widget host addresses options by these, not by our codes.',
    addRow: 'Add code'
  },
  status: {
    draft: 'Draft',
    published: 'Published',
    deactivated: 'Deactivated'
  },
  searchPlaceholder: 'Search twins by name',
  workspace: {
    publish: 'Publish',
    comingSoon: 'Coming soon',
    tabs: {
      variants: 'Variants',
      parts: 'Slots & Parts',
      materials: 'Zones & Materials',
      rules: 'Rules',
      preview: 'Preview'
    }
  },
  simple: {
    steps: {
      model: 'Model',
      parts: 'Parts',
      materials: 'Materials'
    },
    notConfigured: 'not set',
    title: 'Simple mode'
  },
  variants: {
    plural: 'Variants',
    addVariant: 'Add variant',
    createTitle: 'Base model',
    editTitle: 'Base model',
    deleteTitle: 'Delete variant',
    deleteWarning: 'Are you sure you want to delete this variant?',
    defaultLabel: 'Default',
    setDefault: 'Default variant',
    product: 'CRM product',
    baseModel: 'Base model',
    noVariants: 'No variants yet',
    changeBaseModel: 'Replace model',
    noBaseModel: 'No base model yet'
  },
  parts: {
    createTitle: 'Add part',
    addPart: 'Add part',
    save: 'Save',
    remove: 'Remove',
    glbAsset: 'GLB asset',
    noVariants: 'Create a variant first',
    noBaseModel: 'This variant has no base model yet',
    noSockets: 'The base model has no sockets',
    noParts: 'No parts assigned',
    noConnector: 'Part has no connector, cannot assign:',
    compatible: 'Compatible',
    existingGlbAsset: 'Existing asset',
    uploadNewGlbAsset: 'Upload new GLB',
    newGlbAssetName: 'New GLB asset'
  },
  library: {
    searchPlaceholder: 'Search the library',
    empty: 'Nothing in the library yet',
    noGlb: 'No GLB attached',
    noProduct: 'Without a product'
  },
  socketPanel: {
    title: 'Socket rules',
    modeLabel: 'Socket mode',
    acceptByRule: 'Auto-match by rules',
    curatedOnly: 'Curated parts only',
    candidates: 'Resolved candidates',
    noCandidates: 'The widget resolves no candidates for this socket yet',
    candidatesHint:
      'What the widget will actually offer, from the live viewer payload',
    patternAffects: 'This pattern will govern',
    prefixOverMatchWarning:
      'socketPattern is always matched as a prefix — this rule will also cover',
    socketsTitle: 'Model sockets',
    searchPlaceholder: 'Search socket...',
    selectSocket: 'Pick a socket on the left to set up its parts',
    assignedTitle: 'Assigned parts',
    assignedHint: 'Saved with the Save button below',
    inheritedTitle: 'Coming from rules',
    inheritedHint:
      'Resolved by the widget from rules — add one to edit it locally',
    modeHintAcceptByRule:
      'Parts matching the rules are added on top of the assigned ones.',
    modeHintCuratedOnly:
      'Only explicitly assigned parts stay in this socket, rules add nothing.',
    modeSavesImmediately: 'saved immediately',
    nestedOn: 'on',
    emptySocket: 'This socket is empty — assign at least one part.',
    configuredCount: 'configured'
  },
  sections: {
    base: 'Base model',
    slots: 'Slots & parts',
    materials: 'Zones & materials',
    rules: 'Rules',
    preview: 'Preview & publish',
    copyId: 'Copy configurator id',
    copied: 'Copied'
  },
  wizard: {
    title: 'New twin',
    stepBase: 'Base',
    next: 'Next',
    back: 'Back',
    finish: 'Finish',
    createAndContinue: 'Create and continue',
    fromLibrary: 'From the library',
    uploadNew: 'Upload new GLB',
    basisRequired: 'Pick or upload a base model',
    productRequired: 'CRM product is required',
    companyRequired: 'Company is required',
    nameRequired: 'Name is required',
    codeRequired: 'Code is required'
  },
  crm: {
    sectionTitle: '3D',
    rolePart: 'Part',
    roleVariant: 'Base model',
    usedInConfigurators: 'Used in configurators',
    notUsed: 'Not used in any configurator yet',
    usageMayBeIncomplete:
      'Usage counts may be incomplete — too many records to load them all.',
    listMayBeIncomplete:
      'Some records may not be shown — too many to load them all.',
    empty: 'No 3D entities for this product yet',
    materialsEmpty: 'No twin materials for this material yet',
    addModel: 'Add 3D model',
    addTwinMaterial: 'Add twin material',
    roleQuestion: 'What is this model?',
    companyLabel: 'Twin company',
    configuratorLabel: 'Configurator',
    createNewConfigurator: 'Need a new configurator? Open the wizard'
  }
};
